import { render, staticRenderFns } from "./trainingextendedform.vue?vue&type=template&id=61f2e58f"
import script from "./trainingextendedform.vue?vue&type=script&lang=js"
export * from "./trainingextendedform.vue?vue&type=script&lang=js"
import style0 from "./trainingextendedform.vue?vue&type=style&index=0&id=61f2e58f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports